import HTTPHandler, { formatResponse } from 'lib/api/HTTPHandler'
import { API_DIGITAL_URL, API_SIGN_DOCS } from 'lib/api/env'
import { createError } from 'lib/api/serverError'

export class ApiDigital {
  static getDocumentList = async data => {
    try {
      const result = await HTTPHandler.post(API_SIGN_DOCS + '/contract/list', data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static getById = async id => {
    try {
      const response = await HTTPHandler.get(API_DIGITAL_URL + `/${id}`)
      return formatResponse(response)
    } catch (error) {
      return createError(error)
    }
  }

  static getContractById = async id => {
    try {
      const response = await HTTPHandler.get(API_SIGN_DOCS + `/contract/getContractById/${id}`)
      return formatResponse(response)
    } catch (error) {
      return createError(error)
    }
  }

  // static getNewByContractId = async id => {
  //   try {
  //     const response = await HTTPHandler.get(API_SIGN_DOCS + `/document/getContractById/${id}`)
  //     return formatResponse(response)
  //   } catch (error) {
  //     return createError(error)
  //   }
  // }

  static postContractId = async id => {
    try {
      const response = await HTTPHandler.get(API_SIGN_DOCS + `/dealer/sendToSign?signerId=${id}&type=qr`)
      return formatResponse(response)
    } catch (error) {
      return createError(error)
    }
  }

  static sendSmsContracts = async id => {
    try {
      const response = await HTTPHandler.post(API_SIGN_DOCS + `/contract/${id}/send-signing-link`)
      return formatResponse(response)
    } catch (error) {
      return createError(error)
    }
  }

  static getQrBySignerId = async signerId => {
    try {
      const response = await HTTPHandler.get(API_SIGN_DOCS + `/document/getQR/${signerId}`)
      return formatResponse(response)
    } catch (error) {
      return createError(error)
    }
  }

  static deleteDocument = async id => {
    try {
      const response = await HTTPHandler.patch(API_SIGN_DOCS + `/document/${id}/soft-delete`)
      return formatResponse(response)
    } catch (error) {
      return createError(error)
    }
  }

  static getDocumentLink = async id => {
    try {
      const response = await HTTPHandler.get(API_SIGN_DOCS + `/document/${id}/link`)
      return formatResponse(response)
    } catch (error) {
      return createError(error)
    }
  }

  static getResignCount = async id => {
    try {
      const response = await HTTPHandler.get(API_SIGN_DOCS + `/s/${id}/resignCount`)
      return formatResponse(response)
    } catch (error) {
      return createError(error)
    }
  }
}
